import {
  Box,
  Text,
  Flex,
  Spacer,
  HStack,
  useTheme,
  Spinner,
  Center,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import SearchBox from "../../../components/searchbox/SearchBox";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import CustomTable from "../../../components/table/customTable/CustomTable";
import AddChapterModal from "../../../components/modals/AddModals/AddChapterModal";
import { useDisclosure } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getAllChapters } from "../../../store/slice/chapterSlice";
const Chapter = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { chapters, status } = useSelector((state) => state.chapters);
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(5);
  useEffect(() => {
    dispatch(getAllChapters());
  }, [dispatch]);

  const handleAddChapter = () => {
    setEditData(null);
    onOpen();
  };

  const handleEditChapter = (id) => {
    const selectedChapter = chapters.find((chapter) => chapter.id === id);
    if (selectedChapter) {
      setEditData(selectedChapter);
      onOpen();
    }
  };

  const filteredChapter = chapters?.filter((course) =>
    course?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box w={"100%"}>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Chapters
        </Text>
        <Spacer />
        <CourseTextButton text={"Add Chapter"} onClick={handleAddChapter} />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>
      <Box overflow={"scroll"}>
        {status === "loading" ? (
          <Box
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Spinner size="md" color="blue.500" />
          </Box>
        ) : (
          <CustomTable
            data={filteredChapter}
            entityType="chapter"
            onEdit={handleEditChapter}
            extraColumns={[{ label: "Subject", key: "subject" }]}
            limit={limit}
          />
        )}
      </Box>

      <AddChapterModal isOpen={isOpen} onClose={onClose} editData={editData} />
    </Box>
  );
};

export default Chapter;
